import { Component, OnInit } from '@angular/core';
import * as moment from 'moment';
import { SelectItem } from 'primeng/primeng';
import { GUIStatisticsRequest } from '../../models/ss-api/requests/gui.statistics.request';
import { GUIStatisticsItemArray } from '../../models/ss-api/responses/gui.statistics.item';
import { ssApiService } from '../../services/ss-api.service';
import { SortBot } from '../../../app/helpers/sort';
import { Angular2Csv } from 'angular2-csv';
import { GlobalService } from '../../services/global.service';

@Component({
    selector: 'app-gui-stats',
    templateUrl: './gui.stats.component.html',
    styleUrls: ['./gui.stats.component.css']
})
export class GuiStatsComponent implements OnInit {

    IsBusy: boolean = false;

    productOptions: SelectItem[] = [
        { label: 'Vip3D', value: 3 },
        { label: 'Pool Studio', value: 2 },
        { label: 'VizTerra', value: 1 }
    ];

    startDate: Date;
    endDate: Date;
    ignorePara: boolean;

    selectedProducts = [];

    resultRows: number = 25;
    firstResult: number = 0;
    lastResult: number = 25;

    GUIStats: GUIStatisticsItemArray = new GUIStatisticsItemArray();

    constructor(private api: ssApiService, private gb: GlobalService) { }

    SortByPackageID() { this.GUIStats = SortBot.SortAuto(this.GUIStats, 'PackageID'); }
    SortByEventName() { this.GUIStats = SortBot.SortAuto(this.GUIStats, 'EventName'); }
    SortByEventCount() { this.GUIStats = SortBot.SortAuto(this.GUIStats, 'EventCount'); }

    ngOnInit() {
        this.gb.SetPageTitle('GUI Statistics');
        this.ignorePara = true; //init to true
    }

    LoadGUIStats(days?: number) {
        this.IsBusy = true;

        if (days) {
            const today = moment();

            if (days === 30) {
                // Previous month: from first day to last day
                const previousMonth = today.clone().subtract(1, 'month');
                this.startDate = previousMonth.clone().startOf('month').toDate();
                this.endDate = previousMonth.clone().endOf('month').toDate();
            } 
            else if (days === 365) {
                // From first day of the month 12 months ago to last day of last month
                this.startDate = today.clone().subtract(12, 'months').startOf('month').toDate();
                this.endDate = today.clone().subtract(1, 'month').endOf('month').toDate();
            }

        }

        // Ensure default products if none selected
        if (this.selectedProducts.length === 0) {
            this.selectedProducts = [1, 2, 3];
        }

        let request: GUIStatisticsRequest = {
            EndDate: this.endDate,
            StartDate: this.startDate,
            ProductIDs: this.selectedProducts,
            IgnorePara: this.ignorePara
        };

        let disposable = this.api.GUIStatistics(request).subscribe(response => {
            if (response.Result) {
                this.startDate = response.Data.ResolvedStartDate;
                this.endDate = response.Data.ResolvedEndDate;
                this.GUIStats = response.Data.Results;
            }
            this.IsBusy = false;
            disposable.unsubscribe();
        });
    }

    isProductChecked(item) {
        if (this.selectedProducts.indexOf(item.value) >= 0) {
            return true;
        } else {
            return false;
        }
    }

    setProducts(item) {
        if (this.isProductChecked(item)) {
            this.selectedProducts.splice(this.selectedProducts.indexOf(item.value), 1);
        } else {
            this.selectedProducts.push(item.value);
        }
    }

    ExportToCSV() {
        let options = {
            fieldSeparator: ',',
            quoteStrings: '"',
            decimalseparator: '.',
            showLabels: true,
            headers: ['Package', 'Event Name', 'Event Count']
        };

        let ExportData = [];

        this.GUIStats.forEach(function (stat) {
            ExportData.push({
                PackageID: stat.PackageID,
                EventName: stat.EventName,
                EventCount: stat.EventCount
            });
        });

        new Angular2Csv(ExportData, 'GUIStatistics', options);
    }

    paginateGUIStats(e) {
        // console.log("paginateSearch :", e);
        this.firstResult = e.page * e.rows;
        this.lastResult = this.firstResult + e.rows;
    }

}
